<script lang="ts" module>
    export interface FilterData <T> {
        id?: string;
        text?: string;
        currentFilterValue?: string | string[];

        // Controls whether this filter allows for multiselect reference values
        multiselect?: boolean;

        candidateCatalogue?: string[];
        
        isOn?: boolean;
        shouldBeInSet: (o: T, ref: string | string[]) => boolean;
    }

    /**
     * This function filters objects based on a list of filters defined by filterdata. It will see whether the actual filter is active via the isOn property and only then apply its shouldBeInSet
     * Filters are connected with &&. This means all active filters need to return true for an obj out of objs to appear in the returned result
     * @param objs A list of candidate input objects
     * @param arr A list of all available filters (active or not)
     * @returns A filter list of objs
     */
    export function FilterAll<T>(objs: T[], arr :FilterData<T>[]) : T[] {

        let filters: FilterData<T>[] = arr.filter((af: FilterData<T>): boolean => {
            return af.isOn;
        })

        // Define the filter func using all selected filters
        function filterFunc(v: T): boolean {

            for(let filter of filters) {
                if(!filter.shouldBeInSet(v, filter.currentFilterValue)) {
                    return false;
                }
            }
            return true;
        }

        return objs.filter(filterFunc);
    }

</script>